import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Home = lazy(() => import("../pages/home/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const VPNComparisonPage = lazy(() => import("../pages/vpn-comparison/page"));
const WindowsPage = lazy(() => import("../pages/windows/page"));
const OfficePage = lazy(() => import("../pages/office/page"));
const AntivirusPage = lazy(() => import("../pages/antivirus/page"));
const VPNPage = lazy(() => import("../pages/vpn/page"));
const CartPage = lazy(() => import("../pages/cart/page"));
const Distribuidor = lazy(() => import("../pages/distribuidor/page"));
const LoginPage = lazy(() => import("../pages/login/page"));
const AdminPage = lazy(() => import("../pages/admin/page"));
const PanelDistribuidorPage = lazy(() => import("../pages/panel-distribuidor/page"));
const TestimoniosPage = lazy(() => import("../pages/testimonios/page"));
const LegalPage = lazy(() => import("../pages/legal/page"));
const EstudiantesPage = lazy(() => import("../pages/estudiantes/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/windows",
    element: <WindowsPage />,
  },
  {
    path: "/office",
    element: <OfficePage />,
  },
  {
    path: "/antivirus",
    element: <AntivirusPage />,
  },
  {
    path: "/vpn",
    element: <VPNPage />,
  },
  {
    path: "/comparar-vpn",
    element: <VPNComparisonPage />,
  },
  {
    path: "/carrito",
    element: <CartPage />,
  },
  {
    path: "/distribuidor",
    element: <Distribuidor />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/panel-distribuidor",
    element: <PanelDistribuidorPage />,
  },
  {
    path: "/testimonios",
    element: <TestimoniosPage />,
  },
  {
    path: "/legal",
    element: <LegalPage />,
  },
  {
    path: "/estudiantes",
    element: <EstudiantesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;